import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ambulance-profile-edit',
  templateUrl: './ambulance-profile-edit.component.html',
  styleUrls: ['./ambulance-profile-edit.component.css']
})
export class AmbulanceProfileEditComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
